<template>
  <div class="pill-bar sticky-top">
    <ul class="nav nav-pills">
      <li class="nav-item">
        <a
          id="p-all"
          class="nav-link pointer"
          :class="{ active: isActive('p-all') }"
          @click.prevent="handlePillClick"
          >All</a
        >
      </li>
      <li class="nav-item">
        <a
          id="p-popular"
          class="nav-link pointer"
          :class="{ active: isActive('p-popular') }"
          @click.prevent="handlePillClick"
          >Popular</a
        >
      </li>
      <li class="nav-item">
        <a
          id="p-appetisers"
          class="nav-link pointer"
          :class="{ active: isActive('p-appetisers') }"
          @click.prevent="handlePillClick"
          >Appetisers</a
        >
      </li>
      <li class="nav-item">
        <a
          id="p-saltPepper"
          class="nav-link pointer"
          :class="{ active: isActive('p-saltPepper') }"
          @click.prevent="handlePillClick"
          >Salt & Pepper</a
        >
      </li>
      <li class="nav-item">
        <a
          id="p-curry"
          class="nav-link pointer"
          :class="{ active: isActive('p-curry') }"
          @click.prevent="handlePillClick"
          >Curries</a
        >
      </li>
      <li class="nav-item">
        <a
          id="p-sweetSour"
          class="nav-link pointer"
          :class="{ active: isActive('p-sweetSour') }"
          @click.prevent="handlePillClick"
          >Sweet & Sour</a
        >
      </li>
      <li class="nav-item">
        <a
          id="p-chowMein"
          class="nav-link pointer"
          :class="{ active: isActive('p-chowMein') }"
          @click.prevent="handlePillClick"
          >Chow Mein</a
        >
      </li>
      <li class="nav-item">
        <a
          id="p-friedRice"
          class="nav-link pointer"
          :class="{ active: isActive('p-friedRice') }"
          @click.prevent="handlePillClick"
          >Fried Rice</a
        >
      </li>
      <li class="nav-item">
        <a
          id="p-chicken"
          class="nav-link pointer"
          :class="{ active: isActive('p-chicken') }"
          @click.prevent="handlePillClick"
          >Chicken</a
        >
      </li>
      <li class="nav-item">
        <a
          id="p-beef"
          class="nav-link pointer"
          :class="{ active: isActive('p-beef') }"
          @click.prevent="handlePillClick"
          >Beef</a
        >
      </li>
      <li class="nav-item">
        <a
          id="p-pork"
          class="nav-link pointer"
          :class="{ active: isActive('p-pork') }"
          @click.prevent="handlePillClick"
          >Char Siu</a
        >
      </li>
      <li class="nav-item">
        <a
          id="p-kingPrawn"
          class="nav-link pointer"
          :class="{ active: isActive('p-kingPrawn') }"
          @click.prevent="handlePillClick"
          >King Prawn</a
        >
      </li>
      <li class="nav-item">
        <a
          id="p-snackBox"
          class="nav-link pointer"
          :class="{ active: isActive('p-snackBox') }"
          @click.prevent="handlePillClick"
          >Snack Boxes</a
        >
      </li>
      <li class="nav-item">
        <a
          id="p-munchyBox"
          class="nav-link pointer"
          :class="{ active: isActive('p-munchyBox') }"
          @click.prevent="handlePillClick"
          >Munchy Boxes</a
        >
      </li>
    </ul>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { mixpanel } from "../main";

var options = {
  container: ".pill-bar",
  easing: "ease-in",
  offset: -30,
  force: true,
  cancelable: false,
  onStart: (el) => el,
  onDone: (el) => el,
  onCancel: (el) => el,
  x: true,
  y: false,
};

export default {
  name: "PillBar",
  // isActive getter must be a computed property for this to work. WHY?!
  computed: mapGetters(["isActive"]),
  methods: {
    ...mapActions(["filterBy"]),
    scroll(id) {
      // This accesses the vue-scrollto package imported in main.js
      this.$scrollTo(`#${id}`, 700, options);
    },
    handlePillClick(e) {
      const categoryId = e.target.id;

      // If pill is already selected (false), then don't log event.
      if (!this.isActive(categoryId)) {
        mixpanel.track("Menu filtering", {
          "Filter Category": categoryId,
        });
      }

      this.filterBy(categoryId);
      this.scroll(categoryId);
    },
  },
};
</script>

<style scoped>
/* This hides the scroll bar for all elements, although its only scoped to this component, so does not affect other component styles */
::-webkit-scrollbar {
  display: none;
}

ul {
  font-size: 0.85em;
}

.pill-bar {
  background: white;
  border-top: 2px solid #eee;
  border-bottom: 2px solid #eee;
  padding: 10px 10px;
  z-index: 90;
  top: 5em;
}

.nav {
  display: inline-block;
  padding-left: 1em;
  padding-right: 1em;
}

.nav-item {
  display: inline-block;
}

.active {
  background-color: green !important;
  color: white;
  --height: 2.5em;
  height: 2.5em;
  width: auto;
  border-width: 0.1em;
  padding-left: 1.5em;
  padding-right: 1.5em;
  border-color: white;
  border-radius: calc(var(--height) / 2);
  text-align: center;
  font-weight: 500;
}

a {
  color: green;
}

a:hover {
  color: rgb(102, 192, 123);
}

.pointer {
  cursor: pointer;
}

@media screen and (max-width: 767px) {
  .pill-bar {
    overflow-x: auto;
    overflow-y: hidden;
  }

  .nav {
    white-space: nowrap;
  }
}
</style>
